import React from 'react';
import Footer from '../../components/Footer/Footer';
import NavBar from '../../components/NavBar/NavBar';

const LegalInformation: React.FC = () => {
    return (
        <>
            <NavBar />
            <div className='main_content'>
                <h2>LEGAL INFORMATION</h2>
                <div className='container_informations_page'>
                    <h3>1. Website Presentation</h3>
                    <p>The website magicbot.fr is published by the company:</p>
                    <ul>
                        <li>Company name: Arcanit</li>
                        <li>Legal form: Simplified Joint-Stock Company (SAS)</li>
                        <li>Share capital: €1000</li>
                        <li>SIREN number: 983 170 010</li>
                        <li>Registered office address: 23 RUE ANTIGNA 45000 ORLEANS</li>
                        <li>VAT number: FR02983170010</li>
                        <li>Publication Director: Julien Mialon</li>
                    </ul>
                    <h3>2. Website Host</h3>
                    <p>The website is hosted by:</p>
                    <ul>
                        <li>Host name: Hetzner</li>
                        <li>Host address: Hetzner Online GmbH Industriestr. 25 91710 Gunzenhausen, Germany</li>
                        <li>Host phone number: +49 (0)9831 505-0</li>
                    </ul>
                    <h3>3. Intellectual Property</h3>
                    <p>The contents of the website, including but not limited to texts, images, logos, graphics, videos, sounds, software, etc., are the exclusive property of Arcanit, unless otherwise stated. Any reproduction, distribution, modification, or dissemination of these contents is prohibited without prior authorization.</p>
                    <h3>4. Personal Data</h3>
                    <p>In accordance with personal data protection laws, you have the right to access, modify, rectify, and delete your personal data. To exercise this right, you can contact us by email at <a href="mailto:dpo@magicbot.fr">dpo@magicbot.fr</a>.</p>
                    <h3>5. Cookies</h3>
                    <p>We do not use cookies on our website.</p>
                    <h3>6. Liability</h3>
                    <p>We disclaim any responsibility for errors or omissions in the information provided on this site, as well as for any interruptions or malfunctions of the site. We cannot be held responsible for any direct or indirect damages arising from the use of the site.</p>
                    <h3>7. Modifications of Legal Information</h3>
                    <p>We reserve the right to modify this legal information at any time. Any modifications will be published on this page and will take effect upon their publication.</p>
                    <h3>8. Applicable Law</h3>
                    <p>These legal mentions are governed by French law. Any dispute will be subject to the jurisdiction of French courts.</p>
                </div>
            </div>
            <Footer />
        </>
    );
}

export default LegalInformation;
